import { FormFieldConfig } from "../model/api/form-field-config";
import TYPE = FormFieldConfig.TYPE;
import { FieldKind } from "./object-reflection";
import { BatchUtils } from "./batch-utils";

export class BatchFormUtils {

  static buildBatchField<T>(
    field: string,
    kind: FieldKind,
    fieldsToUpdate: string[],
    ccFormDialog: any,
    fieldUpdatePrefix = ''
  ): FormFieldConfig {

    return {
      field: field as string,
      label: field as string,
      column: 3,
      type: this.mapToFormType(kind),

      labelCheckbox: true,
      labelCheckboxChanged: (event, e) =>
        BatchUtils.labelCheckboxChanged(
          fieldsToUpdate,
          ccFormDialog,
          fieldUpdatePrefix + event.field,
          e.checked
        ),

      disabled: () =>
        !fieldsToUpdate.includes(fieldUpdatePrefix + field)
    };
  }

  // ---------------------------------------------------------------------
  // Type mapping
  // ---------------------------------------------------------------------

  static mapToFormType(kind: FieldKind): TYPE {
    switch (kind) {
      case 'number':
        return TYPE.INTEGER;
      case 'boolean':
        return TYPE.CHECKBOX;
      case 'date':
        return TYPE.DATE;
      case 'datetime':
        return TYPE.DATETIME;
      case 'enum':
        return TYPE.DROPDOWN;
      default:
        return TYPE.TEXT;
    }
  }

  // static defaultColumn(kind: FieldKind): number {
  //   switch (kind) {
  //     case 'boolean':
  //       return 2;
  //     case 'number':
  //       return 3;
  //     case 'date':
  //     case 'datetime':
  //       return 4;
  //     default:
  //       return 3;
  //   }
  // }

  // ---------------------------------------------------------------------
  // Generic exclusion helper
  // ---------------------------------------------------------------------

  static isEditable(field: string, excluded: string[]): boolean {
    return !excluded.includes(field);
  }
}
